<template>
    <div>
        <div class="add-policy-form form-item">
            <label for="policy-name" class="textfield-with">{{$t('LABEL.NAME')}}
                <span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span>
            </label>
            <input
                type="text"
                v-model="newPolicy.titl"
                class="text-field"
                id="policy-name"
                :placeholder="$t('POLICY.RULE.PLACEHOLDER.NAME')"
                :data-invalid="invalidNewPolicyTitle"
                @blur="trimWhiteSpace"
                @keyup="checkPlcyName"
            >
            <p class="invalid-message" v-if="invalidNewPolicyTitle">
                {{$t('POLICY.INVALID.TITLE')}}
            </p>
            <p class="invalid-message" v-if="duplicateNewPolicyTitle">
                {{ $t('POLICY.INVALID.DUPLICATE')}}<!--이미 사용 중인 이름입니다.-->
            </p>

        </div>
        <!-- Policy Desc -->
        <div class="form-item">
            <label for="policy-desc" class="textfield-with">{{$t('LABEL.DESCRIPTION')}}</label>
            <textarea name="policy-desc" id="policy-desc" v-model="newPolicy.desc" class="textarea" :placeholder="$t('POLICY.RULE.PLACEHOLDER.DESC')"></textarea>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddPolicyForm",
    data() {
        return {
            newPolicy: {},
            invalidNewPolicyTitle: false
        }
    },
    props: {
        callSetNewPolicy: Function,
        duplicateNewPolicyTitle: false,
    },
    watch: {
        "newPolicy.titl"() {
            this.callSetNewPolicy(this.newPolicy);
        },
        "newPolicy.desc"() {
            this.callSetNewPolicy(this.newPolicy);
        }
    },
    methods: {
        checkPlcyName() {
            this.invalidNewPolicyTitle = !!this.Common.isEmptyText(this.newPolicy.titl);
        },
        trimWhiteSpace() {
            if (this.newPolicy.titl) {
                this.newPolicy.titl = this.newPolicy.titl.trim();
            }
        }
    }
}
</script>

<style scoped>
.add-policy-form input {
    width: 100%;
}

.add-policy-form {
    margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/policy/policyComponents/AddPolicyForm.vue